// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fields .field[data-v-93aa1a98]{width:4.1em;display:inline-block;max-width:calc(20% - 4px)}.fields[data-v-93aa1a98] label{font-size:.8em;padding:0 !important;padding-left:3px !important}.title-text[data-v-93aa1a98]{font-size:.9em;margin-left:.2em;margin-bottom:4px}.oldest[data-v-93aa1a98]{margin-top:10px}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
